import React from 'react';
import ReactMarkdown from 'react-markdown';

// Import our renderers
import Summary from './ToolRenders/Summary';
import Articles from './ToolRenders/Articles';
import ResearchSummary from './ToolRenders/ResearchSummary'; // <-- 1. IMPORT the new module

// --- Fallback style for code that doesn't match any tool ---
const pinkBoxStyle = {
  backgroundColor: '#fff0f3',
  border: '1px solid #ffccd5',
  color: '#a13b58',
  borderRadius: '8px',
  padding: '16px',
  fontSize: '0.9em',
  fontFamily: '"Fira Code", "Courier New", monospace',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};

// --- Schema Definitions & Component Dictionary ---

// Define the exact fields for the Summary tool
const summaryKeys = [
  'title', 'topic', 'end_goal', 'notes', 
  'ctx_digest', 'ctx_chars', 'used_steps'
];

// Define the identifying key for the Articles tool
const articleKeys = ['articles'];

// Define the identifying key for the Research Summary tool
const researchSummaryKeys = ['research_summary']; // <-- 2. DEFINE the new keys

// Create the "dictionary" to map schemas to components
const toolRenderers = {
  summary: {
    keys: summaryKeys,
    component: Summary,
  },
  articles: {
    keys: articleKeys,
    component: Articles,
  },
  research_summary: { // <-- 3. ADD the new entry
    keys: researchSummaryKeys,
    component: ResearchSummary,
  },
};

// --- Helper function to check for an exact key match ---
const hasExactKeys = (obj, keys) => {
  const objKeys = Object.keys(obj);
  // For single-key cases, check for an exact match
  if (keys.length === 1 && objKeys.length === 1 && objKeys[0] === keys[0]) {
    return true;
  }
  // For multi-key cases, check that all keys are present
  if (objKeys.length !== keys.length) {
    return false;
  }
  const keySet = new Set(objKeys);
  return keys.every(key => keySet.has(key));
};


const MessageRenderer = ({ content }) => {
  return (
    <ReactMarkdown
      components={{
        pre: ({ node, children, ...props }) => {
          const codeText = node?.children[0]?.children[0]?.value;
          if (!codeText) {
            return <pre style={pinkBoxStyle} {...props}>{children}</pre>;
          }

          try {
            const parsedJson = JSON.parse(codeText);

            for (const toolName in toolRenderers) {
              const tool = toolRenderers[toolName];
              if (hasExactKeys(parsedJson, tool.keys)) {
                const ComponentToRender = tool.component;
                return <ComponentToRender data={parsedJson} />;
              }
            }
            
            return <pre style={pinkBoxStyle} {...props}>{children}</pre>;

          } catch (error) {
            return <pre style={pinkBoxStyle} {...props}>{children}</pre>;
          }
        },
      }}
    >
      {String(content || '')}
    </ReactMarkdown>
  );
};

export default MessageRenderer;